import { cn } from '~/lib/utils'
import PrimaryCTA from '../PrimaryCTA/PrimaryCTA'
import SecondaryCTA from '../SecondaryCTA/SecondaryCTA'
import TertiaryLink from '../TertiaryLink/TertiaryLink'

type CTABlockProps = {
  content: Array<Button['data']>
  ctaButtons?: boolean
  backgroundColour?: AllBackgroundColours
  className?: string
}

const CTABlock = ({
  content,
  ctaButtons = true,
  backgroundColour,
  className
}: CTABlockProps) => {
  const buttons = content

  const foregroundColour =
    backgroundColour === 'ink-blue' || backgroundColour === 'mid-blue'
      ? 'white'
      : 'ink-blue'

  return (
    <div className={cn('gap-xs xl:gap-xs-plus flex flex-wrap', className)}>
      {ctaButtons && buttons.length <= 2 && (
        <>
          <PrimaryCTA data={buttons[0]} colour={foregroundColour} />
          {buttons.length > 1 && (
            <SecondaryCTA data={buttons[1]} colour={foregroundColour} />
          )}
        </>
      )}
      {(!ctaButtons || buttons.length > 2) &&
        buttons.map((link: Button['data'], index: Index) => (
          <TertiaryLink data={link} key={index} colour={foregroundColour} />
        ))}
    </div>
  )
}

export default CTABlock
